import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const AfterPayMessage = ({price}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {afterpay} = commerceAPI
    const {configAfterpay} = afterpay || {}

    var enableCartCallout = false
    var apJavaScript = null
    var apCartPlacementId = null
    var apCartMpId = null

    try {
        const jsonConfig = JSON.parse(configAfterpay)

        enableCartCallout = jsonConfig.enableCartCallout
        apJavaScript = jsonConfig.scriptURL
        apCartPlacementId = jsonConfig.cartPlacementID
        apCartMpId = jsonConfig.cartMPID
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (apJavaScript && !document.querySelector(`script[src="${apJavaScript}"]`)) {
            const script = document.createElement('script')
            script.src = apJavaScript
            script.async = true
            script.defer = true
            document.body.appendChild(script)
        }
    }, [apJavaScript])

    return (
        enableCartCallout &&
        apCartMpId &&
        apCartPlacementId &&
        apJavaScript && (
            <Box
                id={`afterpay-message-cart`}
                sx={{
                    'afterpay-placement': {
                        '--messaging-font-size': '12px',
                        margin: 0,
                        '--messaging-font-weight': '300',
                        '--logo-badge-width': '65px',
                        color: 'black.100',
                        fontWeight: '300'
                    }
                }}
            >
                <afterpay-placement
                    data-locale="en_US"
                    data-cart-is-eligible="true"
                    data-is-eligible="true"
                    data-consumer-locale="en_US"
                    data-amount={price}
                    data-placement-id={apCartPlacementId}
                    data-modal-link-style="circled-info-icon"
                    data-mpid={apCartMpId}
                    data-currency="USD"
                    data-size="12"
                    data-badge-theme="white-on-black"
                    data-page-type="cart"
                    data-platform="SFCC/SFRA"
                ></afterpay-placement>
            </Box>
        )
    )
}

AfterPayMessage.propTypes = {
    price: PropTypes.number
}

export default AfterPayMessage
